import { useState } from "react";
import { post } from "../networking/RequestService";
import { toast } from "react-toastify";

const useInviteUser = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const inviteUser = async (params) => {
        setLoading(true);
        setError(null);

        try {
            const payload = {
                fn: "inviteUser",
                email: params.email,
                name: params.name,
                surname: params.surname,
                managername: params.managerName,
            };

            const response = await post(payload);
            if (response && response.data) {
                toast.success("User invited successfully");
                return { data: response.data };
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.text || error?.message || "An unexpected error occurred";
            toast.error(errorMessage);
            setError(errorMessage);
            return { error: errorMessage };
        } finally {
            setLoading(false);
        }
    };

    return { loading, error, inviteUser };
};

export default useInviteUser;
